// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Otis Kit PRO components
import MKBox from "components/MKBox";

// Otis Kit PRO examples
import DefaultBlogCard from "examples/Cards/BlogCards/DefaultBlogCard";

// Images

function Experiences() {
    const post1 = "https://images.pexels.com/photos/1181271/pexels-photo-1181271.jpeg";
    const post2 = "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg";
    const post3 = "https://images.pexels.com/photos/7857539/pexels-photo-7857539.jpeg";
    const logo1 = "https://www.nrconsult.fr/assets/img/Logo.png";
    const logo2 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqQiVA-YsB7Wjm7h6A1rR_irQB9x2KEzCk8LBoWgAoxw&s";
    const logo3 = "https://play-lh.googleusercontent.com/ltYH4Ga5rJvfexwuH9op9DIvMf6UVNoK3VGxOQi8tQNH75PsEN507KO96A4gLdUkuDI";

    return (
        <MKBox component="section" py={7}>
            <Container>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={4} mb={{ xs: 3, lg: 0 }}>
                        <DefaultBlogCard
                            image={post1}
                            category={{ color: "info", label: "Antananarivo" }}
                            title="Ingénieur développement logiciels"
                            description="Pilotage informatique et digitalisation ,gestion de l’infrastructure et des applications internes pour optimiser les processus opérationnels, mise en œuvre 
                            de projets numériques et garantie de la sécurité et performance des systèmes"
                            author={{
                                image: logo1,
                                name: "NR Consult",
                                date: "2022 - 2024 ",
                            }}
                            action={{ type: "external", route: "https://www.nrconsult.fr" }}
                        />
                    </Grid>
                    <Grid item xs={12} lg={4} mb={{ xs: 3, lg: 0 }}>
                        <DefaultBlogCard
                            image={post2}
                            category={{ color: "success", label: "Antananarivo" }}
                            title="Web Master - Designer freelance"
                            description="création de l’identité visuelle et supports marketing, développement et maintenance du site vitrine multilingue optimisé SEO, gestion du contenu produit, et suivi des mises à jour et performances du site."
                            author={{
                                image: logo2,
                                name: "Natiora Mania",
                                date: "Depuis 2021 ",
                            }}
                            action={{ type: "external", route: "https://www.natioramania.com" }}
                        />
                    </Grid>
                    <Grid item xs={12} lg={4} mb={{ xs: 3, lg: 0 }}>
                        <DefaultBlogCard
                            image={post3}
                            category={{ color: "warning", label: "Antananarivo" }}
                            title="Stage ingénierie"
                            description="Digitalisation et optimisation des stocks, suivi des flux de livraison, développement d’une application web et mobile avec MERN Stack et React Native pour la géolocalisation en temps réel des livraisons."
                            author={{
                                image: logo3,
                                name: "JIRAMA",
                                date: "Juin 2020 - Decembre 2020",
                            }}
                            action={{ type: "external", route: "https://www.jirama.mg" }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default Experiences;
